export default __webpack_public_path__ + "static/media/Task-Manager (1).dfd013f1.gif";